import FooterControl from '@/components/FooterControl.vue';

export default {
  name: 'quick-edit',
  components: { FooterControl },
  data() {
    return {
      query: {
        drugName: this.$route.query.drugName || '', // 药品名
        drugType: this.$route.query.drugType || '-1', // 药品类型
        customType: this.$route.query.customType || '', // 自定义类型
        status: this.$route.query.status || -1, // 启用状态
      },
      tableData: [],
      currentPage: parseInt(this.$route.query.currentPage, 10) || 1,
      pageSize: parseInt(this.$route.query.pageSize, 10) || 20,
      total: 0, // 总数据条数
      input8: '',
    };
  },
  methods: {
    // 获取药品列表信息
    getTableData(type) {
      if (type === 1) {
        this.currentPage = 1;
      }
      this.$api.drugControl.drugs({
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        console.log(res);
        this.tableData = res.drugList.map((item) => {
          return {
            ...item,
            isDisabled: (item.isOldDrugData === 1 || item.isDrugInventoried === 1) && item.inventoryThresholdUnit !== '',
          };
        });
        this.total = res.totalSize;
      });
    },
    // 返回
    goback() {
      this.$router.push({
        name: 'drugInfo',
        query: {
          ...this.query,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
        },
      });
    },
    // 保存编辑
    complete() {
      const hospitalDrugs = this.tableData.map((value) => {
        return {
          id: value.id,
          inventoryThresholdMatchUnit: value.inventoryThresholdMatchUnit,
          inventoryThresholdUnit: value.inventoryThresholdUnit,
          goodsShelfCode: value.goodsShelfCode,
          drugPrices: value.drugPrices,
        };
      });
      this.$api.drugControl.convenientEdit({
        hospitalDrugs,
      }).then((res) => {
        console.log(res);
        this.goback();
      });
    },
    // 生成单位集合
    newUnitList(drugUnitPojo) {
      const newUnit = [];
      const drugNew = drugUnitPojo;
      const parentUnitNew = drugUnitPojo.parentUnit;
      const parentUnitLast = drugUnitPojo.parentUnit.parentUnit;
      // 判断一级包装
      if (drugNew.unitName && drugNew.unitName !== '') {
        newUnit.push({ cnName: drugNew.unitName });
      }
      // 判断二级包装
      if (parentUnitNew.unitName && parentUnitNew.unitName !== '') {
        newUnit.push({ cnName: parentUnitNew.unitName });
        // 判断三级包装
        if (parentUnitLast.unitName && parentUnitLast.unitName !== '') {
          newUnit.push({ cnName: parentUnitLast.unitName });
        }
      }
      this.units = newUnit;
      return newUnit;
    },
  },
  mounted() {
    this.getTableData();
  },
  computed: {
    
  },
};
